import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { log } from 'src/app/utils/logging';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { AppState } from 'src/types/appState';

import { allowDirectRouteAccess } from './utils/allowDirectRouteAccess';

export const useLastValidRoute = () => {
  const isDataCleanupComplete = useSelector(
    (appState: AppState) => appState.app.isDataCleanupComplete,
  );
  const navigate = useNavigate();
  const { pathname: currentUrl, search } = useLocation();
  const [loading, setLoading] = useState(true);

  const { getLastValidRoute } = useLocalisedRoutes();

  useEffect(() => {
    if (isDataCleanupComplete && !allowDirectRouteAccess(currentUrl)) {
      const redirectUrl = getLastValidRoute(currentUrl, search);

      if (redirectUrl !== currentUrl) {
        log.info(
          'useLastValidRoute | Redirect to the last valid page',
          redirectUrl,
        );

        navigate(
          {
            pathname: redirectUrl,
            search,
          },
          {
            replace: true,
            state: {
              id: redirectUrl,
            },
          },
        );
      }
    }

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataCleanupComplete]);

  return { loading };
};
